import * as React from "react";
import { StyleSheet } from "react-native";
import { List, Divider } from "react-native-paper";
import Icon from 'react-native-vector-icons/AntDesign';
import routes from "../../routing/routes";
import { blackColor, dividerColor } from "../../common/colors";
import { iconRightList } from "../ModalIcons";
import t from "../../translations";

const ListItem = (props) => {

    return (
        <List.Section style={styles.navigateContainer}>
            <List.Item
                title={t('list_title_ApplicationLanguage')}
                onPress={() => { props.navigation.navigate(routes.ApplicationLanguage) }}
                right={() =>
                    <List.Icon
                        color={blackColor}
                        icon={iconRightList} />} />
            <List.Item
                title={t('list_title_AboutLoriini')}
                onPress={() => { props.navigation.navigate(routes.AboutLoriiniApp) }}
                right={() =>
                    <List.Icon
                        color={blackColor}
                        icon={iconRightList} />} />
            <Divider style={styles.divider} />
            <List.Item
                title={t('list_title_Agreement')}
                onPress={() => { props.navigation.navigate(routes.Agreement) }}
                right={() =>
                    <List.Icon
                        color={blackColor}
                        icon={iconRightList} />} />
            <Divider style={styles.divider} />
            <List.Item
                title={t('list_title_PrivatePolicy')}
                onPress={() => { props.navigation.navigate(routes.Privacy) }}
                right={() =>
                    <List.Icon
                        color={blackColor}
                        icon={iconRightList} />} />
            {/* <Divider style={styles.divider} />
            <List.Item
                title="Oceń aplikację"
                right={() =>
                    <List.Icon
                        color={blackColor}
                    />}
            /> */}
        </List.Section>
    );
};

export default (ListItem);

const styles = StyleSheet.create({
    navigateContainer: {
        top: 0,
        flexDirection: 'column',
        flexWrap: 'nowrap',
        textAlign: 'center',
        justifyContent: 'center',
        color: blackColor,
    },
    divider: {
        width: '94%',
        backgroundColor: dividerColor,
    },
});
